import Vue from 'vue';
import Component from 'vue-class-component';

import Tabs from '@/components/customs-components/Tabs.vue';
import Tab from '@/components/customs-components/Tab.vue';
import ProductSectionComponent from '@/components/index-viewport-components/ProductSectionComponent.vue';
import ProductAlphabeticalComponent from '@/components/index-viewport-components/ProductAlphabeticalComponent.vue';
import { Viewport, IndexViewport } from '@/models/Viewport';
import { ViewportScrollInformations,ViewPortModus, Language, ProductSection, SpaceProperty } from '@/models/ProductModels';
//import {productStruct} from '@/softbooks/StaticDatas';
import {productStructureDe, productStructureEn, spaceKeys } from '@/softbooks/ManualsSoftbook';
import ProductServicePackComponent from '@/components/index-viewport-components/ProductServicePackComponent';


@Component({
   
    components:{
        'fuj-tabs': Tabs,
        'fuj-tab': Tab,
        'product-section': ProductSectionComponent,
        'product-alphabetical': ProductAlphabeticalComponent,
        'servicepack-section' : ProductServicePackComponent
    }
})
export default class Startpage extends Vue{

    public indexViewport:Viewport;
    public isTabGruppedActiv:boolean = true;
    public prodStructProp:any = {};
    public homeHREF:string = 'HomeReference';
    public language:Language;
    public activTab:string='GROUPED'   // 'GROUPED' ALPHABETICAL, SERVICEPACK
    /* homeHREF:viewPort.viewportLanguage===Language.DE?Config.CONTEXT_PATH+'/'+INDEX_PAGE_DE
     :Config.CONTEXT_PATH+'/'+INDEX_PAGE_EN */

    viewportScrollInformations:ViewportScrollInformations = 
{
    language: Language.DE,
    themeUrl:'theme-url',
    spaceKey:'spaceKey',
    prodName:'ProdName',
    contextPath:'Context-Path',  
    spaceName:'Space-Name', 
    isIndex: true,
    isSearch:false,
    searchType:'noneed',
    searchTerm:'Search-Termatik'
}

    constructor(){
        super();
        this.indexViewport = new IndexViewport(Language.DE,this.viewportScrollInformations);
        this.indexViewport.viewportModus = ViewPortModus.STARTPAGE;
        this.indexViewport.viewportEvironment='softbook';
    }

    prodStruct():any{
        //console.log('entering Prodstruct()', this.prodStructProp);
        
        return this.prodStructProp;
    }

    created(){
        //console.log('Grouped Component Created');

        let selTab:string='GROUPED';

        let tabHash:string =  window.location.hash.substr(1).toLowerCase();
        switch (tabHash) {
            case 'alphabetisch':
            case 'alphabetical':
                selTab = 'ALPHABETICAL'; 
                break;
            case 'service-packs':
            case 'service-packs':
                selTab = 'SERVICEPACK';
                break;
        
            default:
                selTab = 'GROUPED';
                break;
        }
           

        this.activTab = selTab;
          

        if(this.$i18n.locale=='en')
        {
            this.language = Language.EN;
            this.indexViewport.utilserv.productStructur = JSON.parse(productStructureEn);
            this.prodStructProp = JSON.parse(productStructureEn);
        }
        else
        {
            this.language = Language.DE;
            this.indexViewport.utilserv.productStructur = JSON.parse(productStructureDe);
            this.prodStructProp = JSON.parse(productStructureDe);
        }   

    }

     getGruppedTabName(){
        return this.$i18n.locale=='de'?"Produktgruppen":"Product Groups";
     }

     getAlphabeticalTabName(){
        return this.$i18n.locale == 'de'?"Alphabetisch":"Alphabetical";
     }

    getAlphabeticalProds(){
                       // console.log('OH THIS SHOULDNTss HAPPEN',this.prodStructProp.alphabeticalProducts );

                       if(this.prodStructProp.alphabeticalProducts){
                         //  console.log('OH THIS SHOULDNT HAPPEN',this.prodStructProp.alphabeticalProducts );
       
                           return Object.entries(this.prodStructProp.alphabeticalProducts);
                       }
        
                       return {};
    }

    getServicePackProds() {
        //console.dir("SERVICE PACK PACK : ",this.prodStructProp.servicePack);
        //console.dir("SERVICE PACK PACK-PROD : ",this.prodStructProp);
        //console.dir("SERVICE PACK PACK-Alpha : ",this.prodStructProp.alphabeticalProducts);
       
        if(this.prodStructProp.servicePacks){
           //console.dir("SERVICE PACK PACK- ENTER-IF : ",this.prodStructProp.alphabeticalProducts);
            return this.prodStructProp.servicePacks; //Object.entries(this.prodStruct.servicePacks);
        }

      // console.dir("SERVICE PACK PACK EMPTY ARRAY : ",this.prodStructProp.servicePacks);

        return [];
     }



}
